// Generated by Melange

import * as ReactRouter from "@tanstack/react-router";
import * as Fx from "../fx/fx.jsx";
import * as Pages__LoginPage from "../pages/loginPage.jsx";
import * as Ppx_deriving_json_runtime from "melange-json.ppx-runtime/ppx_deriving_json_runtime.jsx";
import * as Routes__Root from "./root.jsx";
import * as Stdlib__Fun from "melange/fun.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Stdlib__Result from "melange/result.jsx";
import * as Subsonic__Ping from "../api/subsonic/ping.jsx";

function of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.next;
  return {
    next: v !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v) : "/"
  };
}

function to_json(x) {
  return {
    next: x.next
  };
}

const Search = {
  of_json: of_json,
  to_json: to_json
};

const route = ReactRouter.createRoute({
  component: Pages__LoginPage.make,
  getParentRoute: (function (param) {
    return Stdlib__Fun.$$const(Routes__Root.route, param);
  }),
  loader: (function (param) {
    const next = param.deps.next;
    const state = param.context.store.getState();
    const credentials = state.auth.credentials;
    if (credentials !== undefined) {
      return Fx.runAsync(Fx.$$catch(Fx.map(Subsonic__Ping.make(undefined), (function (param) {
        return Stdlib__Option.some(ReactRouter.redirect({
          replace: true,
          to: next
        }));
      })), (function (param) {
        return {
          TAG: /* Ok */ 0,
          _0: undefined
        };
      })), {
        credentials: credentials
      }).then(function (result) {
        return Promise.resolve(Stdlib__Result.get_ok(result));
      });
    } else {
      return Promise.resolve(undefined);
    }
  }),
  loaderDeps: (function (param) {
    return {
      next: param.search.next
    };
  }),
  path: "/login",
  pendingComponent: Pages__LoginPage.make,
  validateSearch: of_json
});

export {
  Search,
  route,
}
/* route Not a pure module */
